import Vue from 'vue';
import { isAppDebugEnabled } from '@/utils/debug/debugEnv';

const LEGACY_DEVTOOLS_URL =
  'https://chromewebstore.google.com/detail/vuejs-devtools/iaajmlceplecbljialhhkmedjlpdblhp';

function devtoolsExplicitlyEnabled() {
  if (process.env.VUE_APP_VUE_DEVTOOLS === 'true') {
    return true;
  }
  if (typeof window === 'undefined') {
    return false;
  }
  try {
    return window.localStorage?.getItem('VUE_DEVTOOLS') === 'true';
  } catch {
    return false;
  }
}

if (!isAppDebugEnabled()) {
  Vue.config.devtools = false;
} else if (devtoolsExplicitlyEnabled()) {
  Vue.config.devtools = true;
} else {
  Vue.config.devtools = false;
  if (typeof window !== 'undefined' && !window.__VUE_DEVTOOLS_DISABLED_LOG__) {
    window.__VUE_DEVTOOLS_DISABLED_LOG__ = true;
    console.info(
      '[solvit] Vue DevTools bridge 비활성화 (v7 확장과 Vue2 비호환·오버헤드 방지). ' +
        "legacy v6 사용 시 localStorage.setItem('VUE_DEVTOOLS','true') 후 새로고침. " +
        `설치: ${LEGACY_DEVTOOLS_URL}`
    );
  }
}
